import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-12 p-0 border bg-white mb-3" };
const _hoisted_2 = { class: "col-12 border bg-white px-md-3 px-2" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "row pr-2 pl-lg-0 pl-2" };
const _hoisted_5 = {
    class: "col-lg-3 pl-0 pr-4 d-lg-flex d-none placeholder",
    style: { "place-content": "space-between center", "flex-direction": "column", "justify-content": "space-between" }
};
const _hoisted_6 = { class: "col-lg-9 col-12 px-0" };
const _hoisted_7 = {
    class: "col-12 p-0 bg-white mb-3",
    style: { "border": "1px solid #dee2e6", "border-top": "1px solid #fff" }
};
const _hoisted_8 = { class: "text-center p-3 bg-brand_beige_light" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_information = _resolveComponent("product-information");
    const _component_progress_bar = _resolveComponent("progress-bar");
    const _component_back_button = _resolveComponent("back-button");
    const _component_dude_image = _resolveComponent("dude-image");
    const _component_condition_check = _resolveComponent("condition-check");
    const _component_accessory_check = _resolveComponent("accessory-check");
    const _component_cta_button = _resolveComponent("cta-button");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "h2-responsive mt-md-4 mt-3 mb-md-3 mb-1 pb-2" }, "Nur noch 2 Steps zu Deinem Geld", -1)),
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_product_information, {
                user_evaluation: _ctx.user_evaluation,
                "product-data": _ctx.productData,
                "change-product-link": _ctx.changeProductLink,
                product_price_offer: _ctx.product_price_offer
            }, null, 8, ["user_evaluation", "product-data", "change-product-link", "product_price_offer"])
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_progress_bar, {
                progress_percent: _ctx.progress_percent,
                user_evaluation: _ctx.user_evaluation,
                current_step: _ctx.current_step,
                onEmitStepBackLink: _ctx.stepBack
            }, null, 8, ["progress_percent", "user_evaluation", "current_step", "onEmitStepBackLink"]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createVNode(_component_back_button, { onEmitStepBack: _ctx.stepBack }, null, 8, ["onEmitStepBack"]), [
                            [_vShow, _ctx.show_back_button]
                        ]),
                        _createVNode(_component_dude_image, { current_step: _ctx.current_step }, null, 8, ["current_step"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_condition_check, {
                            user_evaluation: _ctx.user_evaluation,
                            current_step: _ctx.current_step,
                            conditions_and_texts: _ctx.conditions_and_texts,
                            onEmitProductCondition: _ctx.setProductCondition
                        }, null, 8, ["user_evaluation", "current_step", "conditions_and_texts", "onEmitProductCondition"]),
                        _createVNode(_component_accessory_check, {
                            user_evaluation: _ctx.user_evaluation,
                            current_step: _ctx.current_step,
                            onEmitProductEquipmentComplete: _ctx.equipmentStatus,
                            onEmitProductOriginalPackaging: _ctx.originalPackaging
                        }, null, 8, ["user_evaluation", "current_step", "onEmitProductEquipmentComplete", "onEmitProductOriginalPackaging"]),
                        _createVNode(_component_cta_button, {
                            id: "confirmButton",
                            denied: _ctx.denied,
                            progress_percent: _ctx.progress_percent,
                            current_step: _ctx.current_step,
                            onEmitSubmit: _ctx.submit
                        }, null, 8, ["denied", "progress_percent", "current_step", "onEmitSubmit"])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", {
                    title: "Weitere Informationen anzeigen",
                    class: "font6-responsive pointerhover",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openConditionInfoModal()))
                }, " Brauchst Du Hilfe? Dann klicke hier! ")
            ])
        ])
    ], 64));
}
